import React, { useState, useEffect } from 'react'
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useUpdateQuestionWatchedMutation } from '../../slices/teachers/teacherQuestionsApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherUpload = () => {

    const navigate = useNavigate();

    const { teacherInfo } = useSelector((state) => state.authTeacher);
    
    const { id } = useParams();

    const [isvideo, setIsvideo] = useState(false); 
    const [videoFile, setVideoFile] = useState(null); 
    const [updateQuestionWatched] = useUpdateQuestionWatchedMutation();
    const [loading, setLoading] = useState(false); 

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          if (file.type == 'video/mp4' ||  file.type == 'video/quicktime' || file.type == 'video/avi') { 
            setIsvideo(true); 
            setVideoFile(event.target.files[0]); 
          } 
        } 
      };

    const submitHandler = (event) => {
        event.preventDefault();
        if (isvideo) {
          setLoading(true);
          var fd = new FormData();
          fd.append('upl', videoFile);
          fd.append('id', id);
          fetch('/api/upload/answer',
        {
            method: 'post',
            body: fd,
          })
          .then(response => response.json())
          .then(data => {
            const res =  updateQuestionWatched(id).unwrap();
            setLoading(false);
            navigate(`/teachersubjects`)
            toast.success('Video Saved');
          })
          .catch(error => {
            toast.success('Error uploading video');
          });
        } else {  
          toast.error('Please upload a mp4 or quicktime or avi video file');  
        }
    };

  return (
    <div>
        <TeacherNavbar />
            <div className="main-content" id="panel">
                <TeacherHeader /><br /><br /><br /><br />        
                    <div className="container-fluid mt--6">
                    <div className="row">
                    <div className="col-xl-8 offset-xl-2 ">  
                    <div className="card-wrapper">
                      <div className="card"> <br />
                        <h2 className="centerTitle tittleColor4 ">
                          <span className='tittleColor4'>
                            Upload a video
                          </span>
                        </h2><br />

                        {loading ? ( 
                          <Loader />
                        ) : (  

                        <div className="card-body">
                        <Form onSubmit={submitHandler}>
                          <div className="form-group">
                            <input 
                              type="file" 
                              className="form-control" 
                              onChange={handleFileChange} 
                            />
                          </div>
                          <div className='col-xl-3 offset-xl-4 '>
                            <Button type='submit'  variant='success' className=' uploadBtn btn btn-primary btn-lg btn-block rounded-pill bg-gradient-info uploadVid'>
                            Upload
                            </Button><br /><br /><br />
                            </div>
                        </Form>
                        </div>
                        )} 
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default TeacherUpload
